module.exports = {
    getServerProductName : function(version) {
        version = version || "7.2.1";

        if (this.isGreaterThanOrEqualToServerVersion(version, "7.2.1")) {
            return "Barracuda CloudGen Firewall";
        }
        return "Barracuda NextGen Firewall";
    },

    getClientProductName : function() {
        return "CudaLaunch";
    },

    getVpnProductName : function() {
        return "Barracuda Network Access Client";
    },

    isValidHostname : function(hostname) {
        var portString = "(:(6553[0-5]|655[0-2][0-9]|65[0-4][0-9]{2}|6[0-4][0-9]{3}|[1-5][0-9]{4}|[1-9][0-9]{0,3}))?";
        var IPv4OctetString = "(25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])";
        var IPv4AddressString = "(" + IPv4OctetString + "\\.){3}" + IPv4OctetString;
        var IPv6OpeningSquare = "(\\[(?=[0-9a-fA-F:]+.*\\]))?";
        var IPv6ClosingSquare = "(\\]" + portString + ")?";
        var ValidAddressRegexStrings = [
            IPv4AddressString + portString, //                                                                  IPv4 address
            "(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\\.)*[A-Za-z]+" + portString, //               Hostname
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}" + IPv6ClosingSquare, //                1:2:3:4:5:6:7:8
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){1,7}:" + IPv6ClosingSquare, //                             1::                 1:2:3:4:5:6:7::
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}" + IPv6ClosingSquare, //             1::8                1:2:3:4:5:6::8  1:2:3:4:5:6::8
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}" + IPv6ClosingSquare, //      1::7:8              1:2:3:4:5::7:8  1:2:3:4:5::8
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}" + IPv6ClosingSquare, //      1::6:7:8            1:2:3:4::6:7:8  1:2:3:4::8
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}" + IPv6ClosingSquare, //      1::5:6:7:8          1:2:3::5:6:7:8  1:2:3::8
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}" + IPv6ClosingSquare, //      1::4:5:6:7:8        1:2::4:5:6:7:8  1:2::8
            IPv6OpeningSquare + "[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})" + IPv6ClosingSquare, //           1::3:4:5:6:7:8      1::3:4:5:6:7:8  1::8
            IPv6OpeningSquare + ":((:[0-9a-fA-F]{1,4}){1,7}|:)" + IPv6ClosingSquare, //                         ::2:3:4:5:6:7:8     ::2:3:4:5:6:7:8 ::8       ::
            IPv6OpeningSquare + "[fF][eE]80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]+" + IPv6ClosingSquare, //      FE80::7:8%eth0      fe80::7:8%1     (link-local IPv6 addresses with zone index)
            // (IPv4-mapped IPv6 addresses and IPv4-translated addresses)                                       ::255.255.255.255   ::ffff:255.255.255.255  ::ffff:0:255.255.255.255
            IPv6OpeningSquare + "::([fF]{4}(:0{1,4})?:)?" + IPv4AddressString + IPv6ClosingSquare, //
            // (IPv4-Embedded IPv6 Address)                                                                     2001:db8:3:4::192.0.2.33  64:ff9b::192.0.2.33
            IPv6OpeningSquare + "([0-9a-fA-F]{1,4}:){1,4}:" + IPv4AddressString + IPv6ClosingSquare
        ];
        var ValidAddressRegex = new RegExp("^(" + ValidAddressRegexStrings.join("|") + ")$");

        return ValidAddressRegex.test(hostname);
    },

    isGreaterThanOrEqualToServerVersion : function(version, minAllowed) {
        if (minAllowed === undefined) {
            return true;
        }

        var aVer = toArr(version);
        var minVer = toArr(minAllowed);

        if (aVer[0] > minVer[0]) {
            return true;
        }

        if (aVer[0] == minVer[0] && aVer[1] > minVer[1]) {
            return true;
        }

        return !!(aVer[0] == minVer[0] && aVer[1] == minVer[1] && aVer[2] >= minVer[2]);
    },

    isLessThanOrEqualToServerVersion : function(version, maxAllowed) {
        if (maxAllowed === undefined) {
            return true;
        }
        var aVer = toArr(version);
        var maxVer = toArr(maxAllowed);

        if (aVer[0] < maxVer[0]) {
            return true;
        }

        if (aVer[0] === maxVer[0] && aVer[1] < maxVer[1]) {
            return true;
        }

        return !!(aVer[0] === maxVer[0] && aVer[1] === maxVer[1] && aVer[2] <= maxVer[2]);
    },

    objectLength : function(obj) {
        var size = 0;

        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                size++;
            }
        }
        return size;
    },

    makeBreakText : function(text) {
        var $div = $("<div>");
        var re = /<br>/;
        var lines = text.split(re);

        lines.forEach(function(line) {
            $div.append($("<div>", {text : line}));
        });
        return $div;
    },

    splitTime : function(seconds) {
        const timeSplit = {
            days : 0,
            hours : 0,
            minutes : 0
        };

        if (seconds < 1) {
            return timeSplit;
        }

        if (seconds % 60 > 0) {
            seconds += (60 - (seconds % 60));
        }

        timeSplit.days = Math.floor(seconds / (60 * 60 * 24));
        seconds %= (60 * 60 * 24);

        timeSplit.hours = Math.floor(seconds / (60 * 60));
        seconds %= (60 * 60);

        timeSplit.minutes = Math.floor(seconds / 60);

        return timeSplit;
    },

    formatTimeAsString : function(time, abbrev, reduce) {
        var timeStr = "";

        if (time.days > 0) {
            timeStr += time.days;

            if (abbrev) {
                timeStr += $.t("common::timeSpinner.days.abbreviation");
            } else if (time.days > 1) {
                timeStr += " " + $.t("common::timeSpinner.days");
            } else {
                timeStr += " " + $.t("common::timeSpinner.day");
            }
            timeStr += " ";
        }

        if (time.hours > 0 || (time.days > 0 && !reduce)) {
            timeStr += time.hours;

            if (abbrev) {
                timeStr += $.t("common::timeSpinner.hours.abbreviation");
            } else if (time.hours > 1 || time.hours === 0) {
                timeStr += " " + $.t("common::timeSpinner.hours");
            } else {
                timeStr += " " + $.t("common::timeSpinner.hour");
            }
            timeStr += " ";
        }

        if (!reduce || time.minutes > 0 || timeStr.length === 0) {
            timeStr += time.minutes;

            if (abbrev) {
                timeStr += $.t("common::timeSpinner.minutes.abbreviation");
            } else if (time.minutes > 1 || time.minutes === 0) {
                timeStr += " " + $.t("common::timeSpinner.minutes");
            } else {
                timeStr += " " + $.t("common::timeSpinner.minute");
            }
        }

        return timeStr.trim();
    },

    // Allows submitting of a form by pressing Enter (or a mobile phone equivalent)
    registerKeyboardSubmit : function($input, submitFunction, submitFunctionParam) {
        $input.on("keydown.keyboardSubmit", function(e) {
            var keyCode = e.which;

            // Enter pressed?
            if (keyCode === 10 || keyCode === 13) {
                // Don't use default submit action (because it work just in some browsers (Android 2.2.1))
                e.stopPropagation();
                e.preventDefault();

                // If the input field keeps focus, Samsung Galaxy S3 Stock browser doesn't have a problem closing popups - see BNVS-5202
                $input.trigger("focus");

                // Submit the form with javascript
                submitFunction(submitFunctionParam);
            }
        });
    },

    unregisterKeyboardSubmit : function($input) {
        $input.off("keydown.keyboardSubmit");
    },

    htmlDecode : function(value) {
        return decodeURIComponent(value).replace(/\+/g, " ");
    },

    getHostPort : function() {
        if (location.port && location.port != "") {
            return location.port;
        }

        if (/^https/.test(location.protocol)) {
            return 443;
        }

        return 80;
    },

    getBaseUri : function(forcePort) {
        var uri = location.protocol + "//" + location.hostname;

        if (forcePort || location.port) {
            uri = uri + ":" + this.getHostPort();
        }
        return uri + "/";
    },

    setElementEnabled : function($element, enabled) {
        $element.prop("disabled", !enabled).toggleClass("ui-disabled", !enabled);
    },

    showLoading : function(show) {
        $.mobile.loading(show ? "show" : "hide");
    },

    inherits : function(constructor, superConstructor) {
        // See http://stackoverflow.com/questions/13044957/javascript-inheritance-constructor-called-twice
        // fixes BNNGS-2054

        constructor.prototype = (function() {
            var Base = function() {};
            Base.prototype = superConstructor.prototype;
            return new Base();
        }());
        constructor.prototype.constructor = constructor;
    },

    formatBytesAsString : function(bytes) {
        var suffixes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

        if (bytes < 1024) {
            return bytes + " " + suffixes[0];
        }

        var index = parseInt(Math.floor((Math.log(bytes) * Math.LOG2E) / 10));
        var unitInBytes = Math.pow(1024, index);
        return (bytes / unitInBytes).toFixed(2) + " " + suffixes[index];
    },

    escapeRegexString : function(str) {
        return str.replace(/[.\[\]*?()\-+^${}]/, "\\$&");
    },

    getAuthSchemeDisplayLabel : function(scheme, defaultValue) {
        return $.t(authSchemeDisplayLabels[scheme]) || (defaultValue || $.t("common::login.password"));
    },

    /* Allows iterating over an 'target' object's sub-objects alphabetically,
     * running a 'worker' function for each sub-object (takes sub-object, keyname as inputs)
     *
     * Optionally provide a truish 'invert' object to iterate the sorted sub-objects in reverse
     */
    iterateSorted : function(target, worker, invert) {
        var keys = [];

        for (var key in target) {
            if (target.hasOwnProperty(key)) {
                keys.push(key);
            }
        }

        keys.sort();

        if (invert) {
            keys.reverse();
        }

        for (var i = 0; i < keys.length; i++) {
            worker(target[keys[i]], keys[i]);
        }
    },

    /**
     * Method for filtering object properties (similar to Array.prototype.filter)
     *
     * @param object
     * @param predicate
     */
    objectFilter : function(object, predicate) {
        var result = {};

        // Loop over object keys, keeping only those that return true for the predicate test
        for (var key in object) {
            if (object.hasOwnProperty(key) && predicate(object[key])) {
                result[key] = object[key];
            }
        }

        return result;
    }
};

var authSchemeDisplayLabels = {
    google : "common::totp.title",
    msad : "common::msad.password",
    radius : "common::radius.passwordPrompt.default",
    rsaace : "common::rsaace.title",
    ldap : "common::ldap.password",
    tacplus : "common::tacplus.title",
    msnt : "common::msnt.password",
    ngflocal : "common::login.password"
};

$.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || "");
        } else {
            o[this.name] = this.value || "";
        }
    });
    return o;
};

/* Extends the local storage to (de)serialize objects */
if (!Storage.prototype.setObject) {
    Storage.prototype.setObject = function(key, value) {
        this.setItem(key, JSON.stringify(value));
    };
}

if (!Storage.prototype.getObject) {
    Storage.prototype.getObject = function(key) {
        var value = this.getItem(key);
        return value && JSON.parse(value);
    };
}

function toArr(str) {
    var arr = str.split(".");

    if (arr[0] === undefined) {
        arr[0] = "0";
    }

    if (arr[1] === undefined) {
        arr[1] = "0";
    }

    if (arr[2] === undefined) {
        arr[2] = "0";
    }

    for (var i = 0; i < arr.length; i++) {
        arr[i] = parseInt(arr[i]);
    }
    return arr;
}

Array.prototype.contains = function(item) {
    for (var i = 0; i < this.length; i++) {
        if (item === this[i]) {
            return true;
        }
    }
    return false;
};

Array.prototype.last = function() {
    return (this.length > 0) ? this[this.length - 1] : undefined;
};

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(toFind, position) {
        return this.substr(position || 0, toFind.length) === toFind;
    };
}

// Polyfill for Object.values
if (typeof Object.values !== "function") {
    Object.values = function(obj) {
        var res = [];

        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                res.push(obj[key]);
            }
        }
        return res;
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/Utils.js
// module id = 8
// module chunks = 1 3 4